import React from 'react';
import timeUtils from 'utils/time';
import './styles.css';

const VoucherBalanceList = ({ items }) => (
  <React.Fragment>
    {items.some(item => item.type === 'T') && (
      <div className="company-voucher-group">
        {items
          .filter(item => item.type === 'T')
          .map(item => (
            <div className="company-voucher-item">
              <h3 className="title">{item.title}</h3>
              <label className="total">{`${
                item.discountOperation === 'value' ? '€' : '%'
              } ${item.value}`}</label>
              <label className="title-bottom">Balance</label>
              <label className="bottom">
                {`Expire ${timeUtils.formatDate(item.expireDate)}`}
              </label>
            </div>
          ))}
      </div>
    )}
    {items.some(item => item.type === 'F') && (
      <div className="company-voucher-group">
        {items
          .filter(item => item.type === 'F')
          .map(item => (
            <div className="company-voucher-item">
              <h3 className="title">{item.title}</h3>
              <label className="total">{`${
                item.discountOperation === 'value' ? '€' : '%'
              } ${item.value}`}</label>
              <label className="title-bottom">Balance</label>
              <label className="bottom">
                {`Expire ${timeUtils.formatDate(item.expireDate)}`}
              </label>
            </div>
          ))}
      </div>
    )}
    {items.some(item => item.type === 'R') && (
      <div className="company-voucher-group">
        {items
          .filter(item => item.type === 'R')
          .map(item => (
            <div className="company-voucher-item">
              <label>{`Applicable for € 8 max`}</label>
              <h3 className="title">{item.title}</h3>
              <label className="total">{`${
                item.discountOperation === 'value' ? '€' : '%'
              } ${item.value}`}</label>
              <label className="title-bottom">Balance</label>
              <label className="bottom">
                {`Expire ${timeUtils.formatDate(item.expireDate)}`}
              </label>
            </div>
          ))}
      </div>
    )}
  </React.Fragment>
);

export default VoucherBalanceList;



// WEBPACK FOOTER //
// ./src/containers/TeamVoucher/VoucherBalance/VoucherBalanceList/index.js